<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :paths="paths">
        <template #title>
          <span class="-font-weight-bold">{{ $t('pages_contract_ContractDetail.contractinfo.detail') }}</span>
          <span class="-border-left -mx-2 -font-size-12"></span>
          <span class="-font-weight-medium" id="contract-detail-contractName">{{ contractDetail.contractName }}</span>
        </template>
      </g-page-title>
    </template>
    <g-contents>
      <div class="-tile-container -py-5">
        <div class="-tile-container -wrapper fitting- nowrap-">
          <contract-detail-contract-info @on-selected="onSelectContract"/>
          <div class="-tile-container">
            <contract-detail-cost-trend-month :bill-month="billMonth"/>
            <contract-detail-cost-by-invoice :bill-month="billMonth"/>
          </div>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import ContractDetailContractInfo from './components/ContractDetailContractInfo'
import ContractDetailCostTrendMonth from './components/ContractDetailCostTrendMonth'
import ContractDetailCostByInvoice from './components/ContractDetailCostByInvoice'
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('contract', ['contractDetail']),
  },
  data() {
    return {
      paths: [{
        path: '/contract/info',
        name: this.$t('pages_contract_ContractDetail.contractinfo')
      }, {
        name: this.$t('pages_contract_ContractDetail.contractinfo.detail')
      }],
      billMonth : this.$route.query
    }
  },
  components: {
    ContractDetailContractInfo,
    ContractDetailCostTrendMonth,
    ContractDetailCostByInvoice

  },
  methods: {

    ...mapActions('contract', ['getContractsWithId']),
    onSelectContract(param){
      this.billMonth = param
    }
  },
  beforeMount() {
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/contract/ContractDetail.vue